module.exports = __webpack_public_path__ + "static/media/orquestra_salao_5.fb3182fb.jpg";